"use strict";
import {gh} from '../general/general-helpers';
import initPodcastPlayer from '../podcasts/player-functionality';

(function ($) {
    // Only for .single-article-new class page (new design)
    if ( document.body.classList.contains('single-article-new') ) {

        /* Open all links in the body of post in a new tab
        -------------------------------------------------------------------*/
        $('.event-article').on('click', 'a', function(e) {
            if ( this.hash
                || this.href.includes('javascript:')
                || this.hasAttribute('data-fancybox') )
            {
                return true;
            } // IF
            this.target = '_blank';
        });

        /* Bottom Elements section
        -------------------------------------------------------------------*/
        const bottomElemsSection = document.getElementById('bottom-elems-section');

        function bottomElemsStickySpacing() {
            const carouselWrap = bottomElemsSection.querySelector('#related-on-topic__carousel-wrap');
            if (!carouselWrap) return;

            bottomElemsSection.setAttribute('data-sticky-spacer', carouselWrap.offsetHeight + 685);
        }

        /* Sticky aside blocks
        -------------------------------------------------------------------*/
        let stickyAsides = document.querySelectorAll('.aside-col__sticky, .js-sticky-stop');

        const js_sticky_blocks = (justCSSFixes) => {

            // --- IF MOBILE DESIGN ---
            if (!gh.isDesktopDesign) {
                // css fixes
                document.querySelector('main').classList.add('overflow-hidden');
                gh.body.classList.remove('line-heading-fix');

                // remove height for the parent elements
                stickyAsides.forEach((el, i, list) => {
                    if (el.classList.contains('js-sticky-stop')) return;
                    el.parentElement.style.minHeight = 'initial';
                });
                return
            }

            // --- IF DESKTOP DESIGN ---

            // CSS fix for mobile devices
            if (gh.isMobileDevice) {
                gh.body.classList.add('line-heading-fix');
            }

            // stop function after CSS fixes code
            if (justCSSFixes) return;

            // fix for the bottom-elems-section and its "data-sticky-spacer"
            // because section's elements positioned absolutely and too high
            bottomElemsStickySpacing()

            // CSS fix for desktop
            document.querySelector('main').classList.remove('overflow-hidden');

            // Set width for parent elements of our sticky blocks
            stickyAsides.forEach((el, i, list) => {
                if (el.classList.contains('js-sticky-stop')) return;

                let nextElTopOffset = list[i + 1] ? list[i + 1].getBoundingClientRect().top + window.scrollY : false,
                    // extra spacer that can be set as data attribute
                    nextElStickySpacer = list[i + 1]?.getAttribute('data-sticky-spacer') || 0;

                let marginBetween = 60 + (+nextElStickySpacer), // margin between blocks
                    elRect = el.getBoundingClientRect();


                // IF there is next element/block change height of the current block
                if (nextElTopOffset) {
                    // Description: "nextEl top offset" - "current element top offset" - "margin"
                    // (both offsets are calculated from top of the page)
                    el.parentElement.style.minHeight = nextElTopOffset - (elRect.top + window.scrollY) - marginBetween + 'px';

                } else { // change height to have sticky element until the footer
                    el.parentElement.style.minHeight = (document.getElementById('site-footer').getBoundingClientRect().top + window.scrollY) - (elRect.top + window.scrollY) - 120 + 'px';
                }
            });
        } // FNC
        js_sticky_blocks(true); // fastest call of the function to make CSS fixes first

        gh.doOnEvent({
            load: null,
            resize: 150,
            orientationchange: null, // on window orientationchange (for older browsers)
        }, js_sticky_blocks);


        /* Quote / Highlight blocks
        -------------------------------------------------------------------*/

        // Set height of the accent border
        function quoteTextBorderHeight(mobileDesign = false) {
            document.querySelectorAll('.wp-block-ye-hl-txt__border-bg').forEach((elem) => {
                const textBlock = elem.nextElementSibling.querySelector('.wp-block-ye-hl-txt__text span');

                if (textBlock) {  // Ensure textBlock exists
                    const textBlockHeight = textBlock.getBoundingClientRect().height; // More reliable
                    elem.style.maxHeight = textBlockHeight + 'px';
                }
            });
        } // FNC
        // event which fires only when the screen width is between 1200px and 1320px
        let designChangeLgXl = gh.addMatchMediaOnChangeEvent('(min-width: 1200px) and (max-width: 1320px)',
            (event) => {
                designChangeLgXl = event.matches;
                document.dispatchEvent(new CustomEvent('designChangeLgXl'));
            });

        gh.doOnEvent({
            start: null,
            orientationchange: null, // on window orientationchange (for older browsers)
        }, quoteTextBorderHeight);

        ['designChange', 'designChangeLgXl'].forEach(eventName =>
            document.addEventListener(eventName, function (e) {
                quoteTextBorderHeight();
            }),
        );

        /* Image Slider block
        -------------------------------------------------------------------*/
        $('.wp-block-ye-img-slider__carousel').owlCarousel({
            margin: 60,
            dots: true,
            nav: true,
            loop: true,
            items: 1,
            dotsClass: 'owl-dots d-lg-none',
            navContainerClass: 'owl-nav position-absolute top-50 translate-middle-y mt-lg-0',
            navText: [
                gh.owlSliderCustomNavArrows('both'),
                gh.owlSliderCustomNavArrows('both', false),
            ],
            // autoWidth:  true,
            smartSpeed: 600,
            responsive: {
                0: {
                    margin: 10,
                },
                768: {
                    margin: 30,
                },
                1200: {
                    margin: 60,
                },
            },
        });

        /* Podcast player | block
        -------------------------------------------------------------------*/
        // if NOT single-podcast.php
        if( typeof podcastPage === 'undefined' ) {
            // Inits the whole podcast player functionality
            initPodcastPlayer();
        }

        // click on player's "play bordered area" opens the podcast post in a new browser tab
        // document.getElementById( 'site-content' ).addEventListener( 'click', (evt) => {
        //     if ( evt.target.closest( '.podcast-player__play_wrap' ) ) {
        //         window.open(evt.target.closest('.podcast-block__content').getAttribute('data-url'), '_blank', 'noopener').focus();
        //     }
        // } );


        /* Aside Related Articles slider
        -------------------------------------------------------------------*/
        document.querySelectorAll( '.wp-block-ye-aside-related__carousel' ).forEach( function( carousel ) {

            // shuffle posts inside carousel items
            carousel.querySelectorAll( '.wp-block-ye-aside-related__carousel-item' ).forEach( function(carousel_item) {

                // // shuffle the cloned elements (better performance)
                // const temp = carousel_item.cloneNode( true ); // clone the list
                // for ( var i = temp.children.length + 1; i --; )
                //     temp.appendChild( temp.children[ Math.random() * i | 0 ] );
                //
                // carousel_item.parentNode.replaceChild( temp, carousel_item ); // copy shuffled back to the item

                // shuffle real elements (worse performance but with leave tooltips intact)
                for (var i = carousel_item.children.length; i >= 0; i--) {
                    carousel_item.appendChild(carousel_item.children[Math.random() * i | 0]);
                }
            } );

            // init the slider
            window.addEventListener( 'load', () => {
                $( carousel ).owlCarousel( {
                    margin:    0,
                    dots:      true,
                    nav:       true,
                    mouseDrag: false,
                    touchDrag: gh.isMobileDevice,
                    // loop: true,
                    autoHeight: true,
                    items:      1,
                    navText:    [
                        gh.owlSliderCustomNavArrows( 'mobile', true, 'color-accent', false ),
                        gh.owlSliderCustomNavArrows( 'mobile', false, 'color-accent', false ),
                    ],
                    smartSpeed: 500,
                } );
            } );

        } ); // for each carousel

        /* Info Slider (big gray)
        -------------------------------------------------------------------*/
        $('.wp-block-ye-info-slider__carousel').owlCarousel({
            margin: 0,
            dots: true,
            nav: true,
            loop: true,
            // autoHeight: true,
            navContainerClass: 'owl-nav position-absolute top-50 translate-middle-y mt-lg-0',
            items: 1,
            navText: [
                gh.owlSliderCustomNavArrows('both'),
                gh.owlSliderCustomNavArrows('both', false),
            ],
            smartSpeed: 500,
        });


        /* Info Slider (big gray)
        -------------------------------------------------------------------*/
        // Change hide button after click
        $(document).on('click', '.wp-block-ye-info-slider__btn', function () {
            $(this.parentElement).slideUp();
        });

        /* Back to Top button
        -------------------------------------------------------------------*/
        $(document).on('click', '.back-top-top-btn', function () {
            $(this).off();
            $('html,body').animate({scrollTop: 0}, 800, 'linear');
        });


        /* Posts tag slider
        -------------------------------------------------------------------*/
        // init the slider
        $(window).on('load', function () {
            gh.rowNavSliderInit($('.post-tags-slider'));
        });


        /* Author slider
        -------------------------------------------------------------------*/
        gh.initAuthorsSlider();


        /* Init functionality for "like" and "copy link" buttons + for updating likes/views
        -------------------------------------------------------------------*/
        gh.initExtraBottomButtons();

        /* Code block (for Gutenberg)
        -------------------------------------------------------------------*/
        document.querySelectorAll('.wp-block-ye-code').forEach((elem) => {
            const codeBlock = elem.querySelector('.wp-block-ye-code__code');

            window.addEventListener('load', () => {
                if (codeBlock.scrollHeight <= 200) {
                    elem.classList.add('--short-block')
                }
            });


            $(elem).on('click', '.wp-block-ye-code__btn', function () {
                elem.classList.toggle('show-code');
                codeBlock.style.setProperty('--block-height', codeBlock.scrollHeight + 'px')
            });
        });



        /*==================================================================
        ▐	2. LOWER PRIORITY CODE
        ===================================================================*/
        /* Check accept checkboxes in the comment form
        -------------------------------------------------------------------*/
        // document.addEventListener( 'yadroСommentsAjaxLoaded', () => {
        //     document.querySelectorAll( '.comment-form-cookies-consent, .comment-form-policy' ).forEach( ( elem ) => {
        //         elem.querySelector('label').click()
        //     } );
        // } );
        /* Check accept checkboxes in CF7 form
        -------------------------------------------------------------------*/
        // wpcf7-acceptance

    } // IF this page
})(jQuery);

